export const userIdentifierAttributes = ['id', 'username', 'email', 'firstName', 'lastName'] as const;
